export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Error.vue`
    )
  },
  {
    path: '/',
    meta: {roleId: 1, saveButton: false},
    name: 'Root',
    redirect: {
      name: 'Dashboard'
    }
  },
  {
    path: '/login',
    meta: {
      title: 'Đăng nhập', 
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Login.vue`
    )
  },
  {
    path: '/tai-khoan',
    meta: { title: 'Tài khoản', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 1},
    name: 'Profile',
    component: () => import(
      `@/views/Profile.vue`
    )
  },
  {
    path: '/tong-quan',
    meta: { title: 'Tổng quan', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1},
    name: 'Dashboard',
    component: () => import(
      `@/views/Dashboard.vue`
    )
  },
  {
    path: '/khach-hang/',
    meta: { title: 'Khách hàng', breadcrumb: true, requiresAuth: true, createButton: true, exportButton: true, refreshButton: true, roleId: 2 },
    name: 'CustomerList',
    component: () => import(
      `@/views/Customer/list.vue`
    )
  },
  {
    path: '/khach-hang/:Pid',
    meta: { title: 'Khách hàng', breadcrumb: true, requiresAuth: true, saveButton: true, createButton: true, createButtonText: 'Reset password', createButtonIcon: 'refresh', roleId: 4 },
    name: 'CustomerDetail',
    component: () => import(
      `@/views/Customer/detail.vue`
    )
  },  
  // {
  //   path: '/thanh-toan-don-hang/',
  //   meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 8 },
  //   name: 'PayOrderList',
  //   component: () => import(
  //     `@/views/PayOrder/list.vue`
  //   )
  // },
  // {
  //   path: '/lich-su-thanh-toan/',
  //   meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 16 },
  //   name: 'PayHistoryList',
  //   component: () => import(
  //     `@/views/PaymentHistory/PaymentHistoryList.vue`
  //   )
  // },
  {
    path: '/nap-tien/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 512 },
    name: 'RechargeHistory',
    component: () => import(
      `@/views/RechargeHistory/detail.vue`
    )
  },
  {
    path: '/bao-cao/doanh-thu/',
    meta: { title: 'Báo cáo doanh thu', breadcrumb: true, requiresAuth: true, exportButton: true, refreshButton: true, roleId: 1024 },
    name: 'bao-cao-doanh-thu',
    component: () => import(
      `@/views/Reports/bao-cao-doanh-thu.vue`
    )
  },
  // {
  //   path: '/ma-van-don/',
  //   meta: { breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Nhập kho', createButtonIcon: 'publish', refreshButton: true, roleId: 32 },
  //   name: 'SmallPackage',
  //   component: () => import(
  //     `@/views/Tracking/list.vue`
  //   )
  // },
  {
    path: '/ma-bill/tat-ca/',
    meta: { title: 'Mã bill', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, importButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/nhap-kho-tq/',
    meta: { title: 'Nhập kho TQ', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, importButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_TQ',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/hang-da-xep-xe/',
    meta: { title: 'Hàng đã xếp xe', breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_OnWay',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/nhap-kho-vn/',
    meta: { title: 'Nhập kho VN', breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_VN',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/xuat-kho-vn/',
    meta: { title: 'Hàng đã xuất kho', breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_Ex',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/ma-bill/hang-khong-ten/',
    meta: { title: 'Hàng không tên', breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductNoneOwnerList',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/hang-ton/ton-kho-tq/',
    meta: { title: 'Tồn kho TQ', breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_In_TQ',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/hang-ton/ton-kho-vn/',
    meta: { title: 'Tồn kho VN', breadcrumb: true, requiresAuth: true, refreshButton: true, exportButton: true, roleId: 32 },
    name: 'ProductList_In_VN',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/quan-ly-xep-xe/',
    meta: { title: 'Xếp xe', breadcrumb: true, requiresAuth: true, createButton: true, exportButton: true, refreshButton: true, roleId: 32 },
    name: 'OrderList',
    component: () => import(
      `@/views/Order/list.vue`
    )
  },
  {
    path: '/quan-ly-xep-xe/:Pid',
    meta: { title: 'Xếp xe', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 32 },
    name: 'OrderDetail',
    component: () => import(
      `@/views/Order/detail.vue`
    )
  },
  // {
  //   path: '/tracking/',
  //   meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 2048 },
  //   name: 'Tracking',
  //   component: () => import(
  //     `@/views/Tracking/tracking.vue`
  //   )
  // },
  // {
  //   path: '/quan-ly-kho/',
  //   meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 128 },
  //   name: 'StoreManager',
  //   component: () => import(
  //     `@/views/StoreManager/list.vue`
  //   )
  // }, 
  // {
  //   path: '/quan-ly-bao-hang/',
  //   meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 64 },
  //   name: 'BigPackage',
  //   component: () => import(
  //     `@/views/BigPackage/list.vue`
  //   )
  // },
  {
    path: '/xuat-kho/',
    meta: { title: 'Xuất kho VN', breadcrumb: true, requiresAuth: true, createButton: true, exportButton: true, refreshButton: true, roleId: 4096 },
    name: 'BillList',
    component: () => import(
      `@/views/Bill/list.vue`
    )
  },
  {
    path: '/xuat-kho/:Pid',
    meta: { title: 'Xuất kho VN', breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'In phiếu', createButtonIcon: 'print', saveButton: true, roleId: 4096 },
    name: 'BillDetail',
    component: () => import(
      `@/views/Bill/detail.vue`
    )
  },
  {
    path: '/cai-dat/phi-can-nang/',
    meta: { title: 'Phí cân nặng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256 },
    name: 'FeeWeightList',
    component: () => import(
      `@/views/FeeWeight/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-khoi/',
    meta: { title: 'Phí khối', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256 },
    name: 'FeeVolumeList',
    component: () => import(
      `@/views/FeeVolume/list.vue`
    )
  },
  {
    path: '/cai-dat/cau-hinh-chung',
    meta: {  title: 'Cấu hình chung', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 256},
    name: 'Configuration',
    component: () => import(
      `@/views/Configuration/detail.vue`
    )
  },
  {
    path: '/cai-dat/nhan-vien/',
    meta: { title: 'Nhân viên', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256 },
    name: 'StaffList',
    component: () => import(
      `@/views/Staff/list.vue`
    )
  },
  {
    path: '/cai-dat/nhan-vien/:Pid',
    meta: { title: 'Nhân viên', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 256 },
    name: 'StaffDetail',
    component: () => import(
      `@/views/Staff/detail.vue`
    )
  },
  {
    path: '/cai-dat/kho-nhan/',
    meta: { title: 'Kho nhận', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256 },
    name: 'StorageList',
    component: () => import(
      `@/views/Storage/list.vue`
    )
  },
  {
    path: '/cai-dat/loai-hang/',
    meta: { title: 'Loại hàng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256 },
    name: 'ProductTypeList',
    component: () => import(
      `@/views/ProductType/list.vue`
    )
  }
];
